export const MAGES_DB_KEY = 'mages-1.8'
